angular.module('TurneroApp').component('coRolesModificar', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '=',
    },
    controller: [
        'rolesService',
        'utilsService',
        'TurneroAppConstant',
        function (rolesService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.permisosModificar = [];
            ctrl.rolEditar = {};

            ctrl.errores = {
                N_Rol: false,
                Descripcion: false,
                ListaPermisos: false
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadModificar = function (item) {
                    ctrl.errores = {
                        N_Rol: false,
                        Descripcion: false,
                        ListaPermisos: false
                    };

                    if (item && item.Id_Rol) {
                        rolesService.getInfo({ 'id_rol': item.Id_Rol }).$promise.then(function (res) {
                            ctrl.rolEditar = res;
                            ctrl.obtenerPermisos();
                        }).catch(function (req) {
                            utilsService.errores(req);
                        });
                    }
                }
            }

            ctrl.$onChanges = function () {
                
            }

            ctrl.obtenerPermisos = function () {
                ctrl.permisosModificar = [];
                for (var i = 0; i < ctrl.rolEditar.Permisos_Rol.length; i++) {
                    ctrl.permisosModificar.push({
                        'Id_Permiso': ctrl.rolEditar.Permisos_Rol[i].Id_Permiso,
                        'N_Permiso': ctrl.rolEditar.Permisos_Rol[i].N_Permiso
                    });
                }
                var Permisos = [];
                for (var i = 0; i < ctrl.rolEditar.Permisos_Lista.length; i++) {
                    Permisos.push({
                        'Id_Permiso': ctrl.rolEditar.Permisos_Lista[i].Id_Permiso,
                        'N_Permiso': ctrl.rolEditar.Permisos_Lista[i].N_Permiso
                    })

                }
                ctrl.rolEditar.Permisos_Lista = Permisos;
                ctrl.cambiosEnPermisosEdit();
            };

            ctrl.guardarRolEditado = function () {
                ctrl.errores.ListaPermisos = !(ctrl.rolEditar.Id_Permiso_Alta);
                ctrl.errores.N_Rol = !(ctrl.rolEditar.N_Rol);
                ctrl.errores.Descripcion = !(ctrl.rolEditar.Descripcion);

                if (ctrl.errores.ListaPermisos || ctrl.errores.N_Rol || ctrl.errores.Descripcion) { return }


                rolesService.update(ctrl.rolEditar).$promise.then(function (res) {
                    ctrl.ctrlPadre.grillaReload();
                    sweetAlert("Modificar Rol", "El rol se modificó correctamente", "success");
                }).catch(function (req) {
                    utilsService.errores(req);
                });

            }

            ctrl.cambiosEnPermisosEdit = function () {
                ctrl.rolEditar.Id_Permiso_Alta = '';
                if (ctrl.permisosModificar.length != 0) {
                    for (var i = 0; i < ctrl.permisosModificar.length; i++) {
                        ctrl.rolEditar.Id_Permiso_Alta = ctrl.rolEditar.Id_Permiso_Alta == "" ? ctrl.permisosModificar[i].Id_Permiso.toString() : ctrl.rolEditar.Id_Permiso_Alta + ',' + ctrl.permisosModificar[i].Id_Permiso;
                    }
                }
            };

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.grillaReload();
            }
        }
    ],
    template: require('./rolesModificar.html')
});


// WEBPACK FOOTER //
// ./app/components/roles/rolesModificarComponent.js